/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Action/View
 * @desc Button linking to experiment show
 */

import EntityActionView from 'labstep-web/components/Entity/Action/View';
import type React from 'react';
import type { ExperimentWorkflowActionViewProps } from './types';

export const ExperimentWorkflowActionView: React.FC<
  ExperimentWorkflowActionViewProps
> = ({ experimentWorkflow, ...rest }) => (
  <EntityActionView
    entityName="experiment_workflow"
    dataCy="components/ExperimentWorkflow/Action/View"
    params={{ id: experimentWorkflow.id }}
    {...rest}
  />
);
